export default __webpack_public_path__ + "static/MineralSwimV2_BENEFITS_CustomerCare_1920x1000-28160ecc0fa9edea37dca6af4dcf2782.jpg";